import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Helmet } from 'react-helmet';
import Casestudyback from '../../../../Component/Casestudyback'
import Banner from "../../../../asset/images/insight/case_studies/banner-smarter-nderwriting-20-faster.webp"
import { Link } from 'react-router-dom';

export default function SmarterUnderwriting() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <>
            <Helmet><meta charset="UTF-8" />
                <meta charset="UTF-8" />
                <title>Smarter Underwriting: 20% Faster Processing & 90% Geocoding Accuracy</title>
                <meta name="description" content="Discover how Decimal Point Analytics improved underwriting with 20% faster processing and 90% geocoding accuracy, enhancing decision-making and compliance" />
                <link rel="canonical" href="https://decimalpointanalytics.com/case-study/ai-underwriting-faster-processing-geocoding" />
            </Helmet>

            <Box id="case-studies" className='section sec_bg new_cs' component='section'>

                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={3} alignItems="top" justifyContent='center'>
                        <Grid item lg={9} md={9} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h3' className='subhead skblue al_center'>
                                    Success Stories
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                    Smarter Underwriting: 20% Faster Processing & 90% Geocoding Accuracy
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box>
                        <img loading="lazy" src={Banner} className='w100' alt='Banner' />
                    </Box>

                    <Box className='whitebx'>

                        <Box>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Client Overview
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                A specialty insurance and reinsurance service provider was under pressure to bind critical quote accounts within a 72-hour window, requiring speed, precision, and reliable loss modelling.
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Problem Statement
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Time-sensitive quote processing within 72 hours led to operational bottlenecks and compliance concerns.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Inconsistent data processing and modelling disrupted underwriter timelines and accuracy.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Loss reports were frequently delayed or inaccurate, hampering informed decision-making.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Solution Provided
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                To overcome these challenges, Decimal Point Analytics implemented a comprehensive <Link to="/catastrophe-modeling-services" className='link'>underwriting support solution</Link>:
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Automated Workflow Monitoring: Prioritized quote requests through active work basket monitoring for faster task completion.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Advanced Modelling: Integrated AIR Touchstone for accurate, detailed loss reporting.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Decision Intelligence: Equipped underwriters with well-structured insights, assumptions, and scenarios to accelerate strategic actions.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Geocoding Automation: Employed an in-house tool for real-time geocoding and rapid data scrubbing, ensuring clean, location-verified data inputs.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>


                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Outcome
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>20% reduction</strong> in overall underwriting turnaround time.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            <strong>90% accuracy</strong> in geocoded data, improving modelling inputs and downstream reporting.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Greater trust in loss reports, resulting in faster and more confident underwriting decisions.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Seamless quote handling through refined, tech-enabled workflows.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>

                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Key Takeaway
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                Timely, accurate data-powered by intelligent automation and precision modelling-transforms underwriting from reactive to strategic, enabling insurers to meet strict SLAs with confidence.
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                Facing operational pressure to accelerate underwriting without compromising on accuracy?
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                <Link to="/contact-us#contact_form" className='link'>Book a call</Link> with our experts to explore our <strong>AI-powered underwriting solutions</strong> and see how we can streamline your process.
                            </Typography>

                        </Box>
                    </Box>

                    <Casestudyback />

                </Container>
            </Box>
        </>
    );
}